import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoCorrispondenzaOrdinariaStep2Component
} from './conservazione-carica-documento-corrispondenza-ordinaria-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.conservazione-carica-documento-corrispondenza-ordinaria-step2', {
      url: '/conservazione-carica-corrispondenza-ordinaria',
      ncyBreadcrumb: {
        label: 'Carica Corrispondenza Ordinaria',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      'views': {
        'homeContent': {
          template: '<conservazione-carica-documento-corrispondenza-ordinaria-step2 flex="100"></conservazione-carica-documento-corrispondenza-ordinaria-step2>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoCorrispondenzaOrdinariaStep2Module: string = ng
  .module('conservazione-carica-documento-corrispondenza-ordinaria-step2', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('conservazioneCaricaDocumentoCorrispondenzaOrdinariaStep2', ConservazioneCaricaDocumentoCorrispondenzaOrdinariaStep2Component)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-corrispondenza-ordinaria-step2/conservazione-carica-documento-corrispondenza-ordinaria-step2.module.ts